module.exports = __webpack_public_path__ + "static/media/logo-에스큐엔티@2x.8ee7da3b.png";